import Slider from "react-slick";

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './slider.css';
import UserAppContext from "../../hook/UserAppContext";
    
const SimpleSlider = () => {
      
    const {user} = UserAppContext()
    const {friends} = user.user 
    if(friends.data) return

    const settings = {
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 4000,
            cssEase: 'ease-in-out',
            responsive: [
                  {
                    breakpoint: 1280,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 420,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 300,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
            ]
      };

    return (
      <div>
        <Slider {...settings}>
            {
                  friends.map((friend, index) => (
                        <div className="jd_friend__card" key={index}>
                              <div className="jd_card__inner">
                                    <div className="jd_card__image">
                                          <img src={friend.avatar} alt={friend.name} />
                                    </div>
                                    <div className="jd_card__title">
                                          <h3>{friend.name}</h3>
                                    </div>
                                    <a className="jd_card__link" href={friend.me} target="_blank" rel="noreferrer">xat.me</a>
                              </div>
                        </div>
                  ))
            }
        </Slider>
      </div>
    );
}

export default SimpleSlider;